
import router from '@/router'
import firebase from 'firebase/app'

import { orderBy } from 'lodash'
import generate from 'nanoid/generate'




export default {
  // This makes your getters, mutations, and actions accessed by, eg: 'myModule/myModularizedNumber' instead of mounting getters, mutations, and actions to the root namespace.
  namespaced: false,


  state: {
    user: null,
    notifications: [],
    myFriends: [],
    favEvents: [],
    favMoments: [],

    isNotVerified: null,
    pleaseVerifyMail: false,
    currentUserFireBaseEmail: null
  },


  getters: {
    user (state) {
      return state.user
    },
    // ordered Notifications (1. new, 2. requestTime)
    orderedNotifications (state) {
      return orderBy(state.notifications, [
        'new',
        'requestTime'
      ], [
        'desc',
        'desc'
      ])
    },
    // Number of new Notifications (for Badge)
    notifications_num (state) {
      // return state.notifications.length
      return state.notifications.filter(notification => notification.new === true).length
    },
    
    isNotVerified (state) {
      const notVerifiedUser = {
        isNotVerified: state.isNotVerified,
        currentUserFireBaseEmail: state.currentUserFireBaseEmail
      }
      return notVerifiedUser
    }
  },


  mutations: {
    setUser: (state, payload) => {
      state.user = payload
    },
    setMyFriends: (state, payload) => {
      state.myFriends.push(payload)
    },
    setNotifications: (state, payload) => {
      state.notifications.push(payload)
    },
    setFavMoments: (state, payload) => {
      state.favMoments.push(payload)
    },
    setFavEvents: (state, payload) => {
      state.favEvents.push(payload)
    },
    delFavMoments: (state, payload) => {
      var filtered = state.favMoments.filter(function(value, index, arr) {
        return value.id !== payload.id
      })
      state.favMoments = filtered
    },
    delFavEvents: (state, payload) => {
      var filtered = state.favEvents.filter(function(value, index, arr) {
        return value.id !== payload.id
      })
      state.favEvents = filtered
    },
    changeNotification (state, payload) {
      var index = state.notifications.findIndex(not => not.notificationId === payload.notificationId)
      state.notifications[index].new = false

    },
    removeFriend: (state, payload) => {

      // FriendId aus Array entfernen / filtern
      var filtered = state.myFriends.filter(function(value, index, arr){
        
        return value.friendId !== payload
    
      })
      
      // Array ohne FriendId übernehmen
      state.myFriends = filtered
    },

    setUserName: (state, payload) => {
      state.user.name = payload
    },
    setUserStatus: (state, payload) => {
      state.user.status = payload
    },
    setUserIsNew: (state, payload) => {
      state.user.flags.userIsNew = payload
    },
    setUserProfileImg: (state, payload) => {
      state.user.profileImg = payload
    },
    setUserFilter: (state, payload) => {
      state.user.filter = payload
    },

    setIsNotVerified(state, payload) {
      state.isNotVerified = true
      state.currentUserFireBaseEmail = payload
    },
    setPleaseVerifyMail(state, payload) {
      state.pleaseVerifyMail = payload
    },
    
    delIsNotVerified(state) {
      state.isNotVerified = null
      state.currentUserFireBaseEmail = null
    },
  },

  actions: {
    logout ({commit}) {
      firebase.auth().signOut()
      router.push('/')

      
      // commit('delIsNotVerified')
      // commit('setUser', null)
      commit('click_profile_settingsdrawer', false)
      
      commit('restoreVuexStore')
    },
  
    // disableAccount () {
    //   let user = firebase.auth().currentUser
    //   if (user) {
  
    //     user.updateProfile({
    //       disabled: 'true1',
  
    //       displayName1: 'Jane QQQ. User',
    //       displayName: 'Jane Q!. User',
    //     }).then(function() {
    //       console.log('disabled', user)
    //       // Update successful.
    //     }).catch(function(error) {
    //       // An error happened.
    //       console.log(error)
    //     })
        
    //   }
    // },
  
  
    

    
  
    changeEmail ({commit, dispatch}, payload) {
      commit('clearError')
      commit('clearSuccess')
      commit('setLoading', true)
      let user = firebase.auth().currentUser
      const credential = firebase.auth.EmailAuthProvider.credential(
        payload.emailOld,
        // userProvidedPassword
        payload.passwordEmail
      )
      if (user) {
        console.log('changeEmailbefore', user)
  
        user.reauthenticateAndRetrieveDataWithCredential(credential).then(function() {
          // User re-authenticated.
          user.updateEmail(payload.emailNew).then(function() {
            // Update successful.
            // let user1 = firebase.auth().currentUser
            // searchEmail
            // console.log('changeEmailafter', user1)
            commit('setLoading', false)
            commit('setSuccess', 'E-Mail-Adresse geändert in ' + payload.emailNew)

            firebase.firestore().collection('users').doc(user.uid).update({
              email: payload.emailNew,
              searchMail: payload.emailNew.toUpperCase()
            })
              .then(() => {
                
              })
              .catch(error => {
                // commit('setLoading', false)
                commit('setError', error)
              })
  
          })
            .then(() => {
              dispatch('sendVerificationMail')

            })
            
            .catch(function(error) {
            // An error happened.
              console.log('error', error)
              commit('setLoading', false)
              commit('setError', error)

  
            })
        }).catch(function(error) {
          // An error happened.
          console.log('errorReAuth', error)
          commit('setLoading', false)
          commit('setError', error)
  
        })
  
  
  
        
      }      
    },
  
    changePassword({commit}, payload) {
      commit('clearError')
      commit('clearSuccess')
      commit('setLoading', true)
      let user = firebase.auth().currentUser
      const credential = firebase.auth.EmailAuthProvider.credential( 
        user.email,
        // userProvidedPassword
        payload.passwordOld
      )
      if (user) {
        console.log('changePasswordBefore', user)
  
        user.reauthenticateAndRetrieveDataWithCredential(credential).then(function() {
          // User re-authenticated.
          user.updatePassword(payload.passwordNew).then(function() {
            // Update successful.
            // let user1 = firebase.auth().currentUser
  
            // console.log('changeEmailafter', user1)
            console.log('PW changed')
            commit('setLoading', false)
            commit('setSuccess', 'Passwort geändert!')

          }).catch(function(error) {
            // An error happened.
            console.log('error', error)
            commit('setLoading', false)

  
          })
        }).catch(function(error) {
          // An error happened.
          console.log('errorReAuth', error)
          commit('setLoading', false)
          commit('setError', error)

  
        })
  
  
  
        
      }      
    },

    dontdisplayWelcomeCard ({commit, dispatch, rootState}) {
      commit('clearError')

      let user = firebase.auth().currentUser
      let userVuex = rootState.user.user
      if (user) {
        if (userVuex.flags.userIsNew === true) {
          firebase.firestore().collection('users').doc(user.uid).update({
            flags: { userIsNew: false }
          })
            .then(() => {
              // let openingEvent = {
              //   title: 'WeVent Release - created by ' + userVuex.name,
              //   location: userVuex.filter.location,
              //   coordinates: userVuex.filter.coordinates,
              //   description: 'WeVent will start today!!!!!',
              //   date: new Date('01 August 2019 14:48 UTC'),
              //   mainCat: 'MeetUp',
              //   secondCat: 'Party',
              //   creatorId: userVuex.id,
              //   uniqueId: userVuex.uniqueId,
              //   createdTime: new Date().toISOString(),
              //   link: '',
              //   image: null,
              //   standardImage: 'OpeningHeader.jpg'
              // }
              // dispatch('createEvent', openingEvent)
              // console.log('openingEvent', openingEvent)
              console.log('hallooooooo')
              let date = new Date()
              let dateplus5day = new Date(date.setDate(date.getDate() + 10))

              let openingMoment = {
                title: 'Mein erster Moment ;)',
                location: userVuex.filter.location,
                coordinates: userVuex.filter.coordinates,
                description: 'Ich nehme am WeVent Test teil!!! - Man, bin ich eine coole Socke!',
                date: dateplus5day,
                mainCat: 'Fun',
                secondCat: 'Party',
                creatorId: userVuex.id,
                createdTime: new Date().toISOString(),
              }
              console.log('openingMoment', openingMoment)
              dispatch('createMoment', openingMoment)
            })
            .then(() => {
              commit('setUserIsNew', false)
              // commit('setLoading', false)
            })
            .catch(error => {
              // commit('setLoading', false)
              commit('setError', error)
            })
        }
        
      }
    },

    updateProfile ({commit, dispatch, rootState}, payload) {
      commit('clearError')
      // firebase.auth().onAuthStateChanged((user) => {
      let user = firebase.auth().currentUser
      if (user) {
        // console.log('profileupdate', user)
        if (payload.name) {
          // commit('setLoading', true)
  
          user.updateProfile({
            displayName: payload.name,
          }).then(function() {
            // Update successful.
            firebase.firestore().collection('users').doc(user.uid).update({
              // firebase.database().ref('users/' + user.uid).update({
              name: payload.name,
              searchName: payload.name.toUpperCase(),
              nameChanged: new Date().toISOString()
            })
              .then(() => {
                commit('setUserName', payload.name)
                // commit('setLoading', false)
              })
              .catch(error => {
                // commit('setLoading', false)
                commit('setError', error)
              })
          }).catch(function(error) {
            // An error happened.
            console.log(error)
            commit('setError', error)

          })
  
          
        }
  
        if (payload.status) {
          // commit('setLoading', true)
          firebase.firestore().collection('users').doc(user.uid).update({
          // firebase.database().ref('users/' + user.uid).update({
            status: payload.status
          })
            .then(() => {
              commit('setUserStatus', payload.status)
              // commit('setLoading', false)
            })
            .catch(error => {
              // commit('setLoading', false)
              commit('setError', error)
            })
        }
  
        if (payload.profileImg) {
          commit('setLoading', true)
          console.log('setLoading 4')

          let imgUrl
            
          // const filename = payload.profileImg.name
          // const ext = filename.slice(filename.lastIndexOf('.'))
          firebase.storage().ref('users/' + user.uid + '/' + user.uid).put(payload.profileImg)
        
            .then(fileData => {
              let imagePath = fileData.metadata.fullPath
              return firebase.storage().ref().child(imagePath).getDownloadURL()
                .then(url => {
                  imgUrl = url
                  // return firebase.database().ref('users/' + user.uid).update({profileImg: imgUrl})
                  return firebase.firestore().collection('users').doc(user.uid).update({profileImg: imgUrl})
                })
                .then(() => {
                  commit('setUserProfileImg', imgUrl)
                  commit('setLoading', false)
                })
                .catch(error => {
                  commit('setLoading', false)
                  commit('setError', error)
                })
            })
            .catch(error => {
              commit('setLoading', false)
              commit('setError', error)
            })
        }
        
      }
  
      // })
      
    },

    saveFilter ({commit, dispatch}, payload) {
      commit('clearError')
      commit('setLoading', true)

      let user = firebase.auth().currentUser
      if (user) {

        let stringPayload = JSON.parse(JSON.stringify(payload))

        let filterDB = {
          activity: stringPayload.activityFilter,
          categories: stringPayload.categoriesFilter,
          distance: stringPayload.distanceFilter,
          location: stringPayload.locationFilter,
          coordinates: stringPayload.coordinatesFilter
        }

        let timelineStandardFilter = {
          activityFilter: stringPayload.activityFilter,
          categoriesFilter: stringPayload.categoriesFilter,
          distanceFilter: stringPayload.distanceFilter,
          locationFilter: stringPayload.locationFilter,
          coordinatesFilter: stringPayload.coordinatesFilter
    
        }

        let timelineResetFilter = {
          locationFilter: stringPayload.locationFilter,
          coordinatesFilter: stringPayload.coordinatesFilter
        }

        firebase.firestore().collection('users').doc(user.uid).update({filter: filterDB})
          .then(() => {
            dispatch('filterPosts', {isFilterSet: true})
          })  
          .then(() => {
            commit('setStandardFilter', timelineStandardFilter)
            commit('setResetFilter', timelineResetFilter)
            // commit('setFilter', filter)
            commit('setUserFilter', filterDB)
            commit('setLoading', false)
          })
         
          .catch(error => {
            commit('setLoading', false)
            commit('setError', error)
          })
        
      }
    },

    loadFilter ({commit, dispatch}, payload) {
      commit('clearError')
      commit('setLoading', true)


      // setTimeout(function() {
      commit('setFilter', payload)
      commit('setLoading', false)
      dispatch('filterPosts', ({isFilterSet: true}))

      // }, 500)
      
    },

    changeNotification({commit}, payload) {
      commit('clearError')
      let user = firebase.auth().currentUser
      var friendNotificationsRef = firebase.firestore().collection('users').doc(user.uid).collection('notifications').doc(payload.notificationId)
      friendNotificationsRef.update({new: false})
        .then(function() {
          console.log('Document successfully updated!')
          commit('changeNotification', payload)
        })
        .catch(function(error) {
        // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
    

    },
  
    sendVerificationMail () {
      firebase.auth().currentUser.sendEmailVerification()
        .then(function() {
          // Email sent.
        })
        .catch(function(error) {
          // An error happened.
          console.log(error)
        })
    },

    sendPasswordResetMail ({commit}, email) {

      var auth = firebase.auth()
      var emailAddress = email.email
      
      auth.sendPasswordResetEmail(emailAddress).then(function() {
        // Email sent.
      }).catch(function(error) {
        // An error happened.
        console.log(error)
      })
    },
  
    signUserUp ({commit, rootState}, payload) {
      let user
      let existingUniqueId = ''
      let zaehler = 0

      commit('setLoading', true)

      commit('clearError')

      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(userFireBase =>  {
          // console.log('userSignUp', user.user)
          user = userFireBase

          let checkUniqueId = function() {
            let uniqueId = generate('0123456789abcdefghijklmnopqrstuvwxyz', 8)
            console.log(uniqueId)

            firebase.firestore().collection('users').where('uniqueId', '==', uniqueId).limit(1).get()
              .then(function(querySnapshot) {
                querySnapshot.forEach((doc) => {
                  existingUniqueId = doc.data().uniqueId
                
                })
              })
              .then(()=> {
                if (existingUniqueId === uniqueId && zaehler < 25) {
                  checkUniqueId()
                  existingUniqueId = ''
                  zaehler = zaehler + 1
                } else if (zaehler < 25) {
                  createUserProfile(uniqueId)
                } else {
                }

              })
              .catch(function(error) {
              
                console.log('Error getting document: ', error)
              })
          }


          let createUserProfile = function(uniqueId) {
            let categories = []
            for (const key of Object.keys(rootState.categories)) {
              categories.push(key)
            }

            const newUser = {
              id: user.user.uid,
              uniqueId: uniqueId,
              email: user.user.email,
              name: payload.name,
              flags: {
                userIsNew: true 
              },
              searchName: payload.name.toUpperCase(),
              searchMail: user.user.email.toUpperCase(),
              birthday: payload.birthday,
              displayBDay: payload.displayBDay,
              subscribeNewsletter: payload.subscribeNewsletter,
              
              nameChanged: new Date().toISOString(),
              accountCreated: new Date().toISOString(),
              profileImg: process.env.VUE_APP_GOOGLE_FIREBASE_PROFILE_IMG,
              
              status: 'Hey! I\'m new to WeVent!',
              acceptTerms: payload.acceptTerms,
              filter: {
                activity: [
                  'events',
                  'eventsbyfriends',
                  'moments'
                ],
                distance: 50,
                location: payload.location,
                coordinates: payload.coordinates,
                categories: categories
              },
              
            }
            firebase.firestore().collection('users').doc(user.user.uid).set(newUser)
              .then(function(docRef) {
                console.log('newUserCreated', newUser)
                commit('setLoading', false)
                // user automatisch einloggen -> deaktiviert, da email erst verifiziert sein muss
                // commit('setUser', newUser)
              })
              
              .catch(function(error) {
                commit('setLoading', false)
  
                console.error('Error adding document: ', error)
              })
          }
          



          checkUniqueId()

        })
       


   
       
        .then(() => {
          firebase.auth().currentUser.sendEmailVerification()
            .then(function() {
            // Email sent.
            })
            .catch(function(error) {
            // An error happened.
              console.log(error)
            })
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log('UserSignUpError', error)
        })
    },
  
    
  
    loginUser ({rootState, commit, dispatch}, payload) {
      commit('setLoading', true)
      commit('setPleaseVerifyMail', false)
      commit('clearError')
      console.log('startLoginUser')

      // let checkUser = firebase.auth().currentUser
      // if (checkUser && rootState.user.isNotVerified) {
      //   dispatch('logout')
      // } else {
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
      // wird dann über AutoSignIn gehandled
  
        .then(user =>  {
          // const userAuth = {
          //   id: user.user.uid,
          //   email: user.user.email,
          // }
          console.log('loginuser', user)
          // dispatch('autoSignIn', user.user)
          if (user && user.user.emailVerified === false && rootState.user.isNotVerified) {
            dispatch('logout')
            console.log('notVerifiedByLogin')
            commit('setPleaseVerifyMail', true)
  
            // router.push('/')
            // dispatch('autoSignIn', user.user)
            // window.location.reload()
          } else if (user && user.user.emailVerified === true && rootState.user.isNotVerified) {
            // reload page to login after Email was verified 
            // only when same user will log in
            console.log('issdd1', rootState.user.currentUserFireBaseEmail)
            if (user.user.email === rootState.user.currentUserFireBaseEmail) {
              // setTimeout(function() {
              window.location.reload()
              // }, 33)
            }
           
          }
  
          commit('setLoading', false)
        })
        // firebase.firestore().collection('users').doc(userAuth.id).get()
        //   .then((userdoc) => {
        //     const obj = userdoc.data()
        //     const loggedInUser = {
        //       id: payload.uid,
        //       email: obj.email,
        //       name: obj.name,
        //       birthday: obj.birthday,
        //       location: obj.location,
        //       coordinates: obj.coordinates,
        //       events: obj.events,
        //       moments: obj.moments,
        //       profileImg: obj.profileImg,
        //       status: obj.status,
        //       categories: obj.categories,
        //       nameChanged: obj.nameChanged
        //     }
        //     commit('setLoading', false)
        //     commit('setUser', loggedInUser)
        //   })
        //   .catch((error) => {
        //     console.log('UserLoginError', error)
        //     commit('setLoading', false)
        //     commit('setError', error)
        //   })
            
        // })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          dispatch('logout')
          console.log('UserLoginError1', error)
        })
      // }

      
    },
  


    autoSignIn({commit, dispatch, rootState, rootGetters}, payload) {
      commit('setLoading', true)
      commit('setRefreshLoading', true)
      commit('clearError')

      console.log('startAutoSignin', payload)
      let user
      let date = new Date()
      let dateminus1day = new Date(date.setDate(date.getDate() - 1)).toISOString()

      if ( payload.emailVerified ) {
        console.log('emailIstVerifiziert -> Datenbankzugriff')
        commit('delIsNotVerified')

        firebase.firestore().collection('users').doc(payload.uid).get()
          .then((userdoc) => {
            const obj = userdoc.data()
            // const loggedInUser = {
            //   id: payload.uid,
            //   email: obj.email,
            //   name: obj.name,
            //   birthday: obj.birthday,
            //   location: obj.location,
            //   profileImg: obj.profileImg,
            //   status: obj.status,
            //   categories: obj.categories,
            //   nameChanged: obj.nameChanged,
            // }
            const filter = {
              activityFilter: obj.filter.activity,
              locationFilter: obj.filter.location,
              coordinatesFilter: obj.filter.coordinates,
              categoriesFilter: obj.filter.categories,
              distanceFilter: obj.filter.distance
            }

            let standardFilter = JSON.parse(JSON.stringify(filter))


            let categories = []
            for (const key of Object.keys(rootState.categories)) {
              categories.push(key)
            }

            let resetFilter = {
              locationFilter: JSON.parse(JSON.stringify(filter.locationFilter)),
              coordinatesFilter: JSON.parse(JSON.stringify(filter.coordinatesFilter)),
              categoriesFilter: categories
            } 

            commit('setFilter', filter)
            console.log('setTimelineFilter', filter)

            commit('setStandardFilter', standardFilter)
            commit('setResetFilter', resetFilter)
            console.log('DB_UserInfo', obj)
            user = obj
            // commit('setUser', user)
          })
          .then(() => {
            commit('setUser', user)
            router.push('/timeline')
          })
          .then(() => {
            return firebase.firestore().collection('users').doc(payload.uid).collection('friends').get()
              .then((friendsList) => {

                friendsList.forEach((friendDoc) => {
                  const friend = friendDoc.data()
                  console.log('friend', friend)
                  firebase.firestore().collection('users').doc(friend.friendId).get()
                    .then((friendSnapshot) => {
                      if (friendSnapshot.exists) {
                        const friendData = {
                          friendId: friendSnapshot.data().id,
                          uniqueId: friendSnapshot.data().uniqueId,
                          friendName: friendSnapshot.data().name,
                          friendSearchName: friendSnapshot.data().searchName,
                          friendStatus: friendSnapshot.data().status,
                          friendProfileImg: friendSnapshot.data().profileImg,
                          acceptedByFriend: friend.acceptedByFriend,
                          acceptedByUser: friend.acceptedByUser,
                          requester: friend.requester,
                          requestTime: friend.requestTime,
                          notificationId: friend.notificationId
                        }
                        
                        commit('setMyFriends', friendData)
                        console.log('friendData', friendData)
                      } else {

                        // Delete Friend Doc (because User was deleted)
                        firebase.firestore().collection('users').doc(payload.uid).collection('friends').doc(friendDoc.id).delete()
                          .then(function() {
                            console.log('Document successfully deleted!')
                          })
                          .catch(function(error) {
                            console.error('Error removing document: ', error)
                          })


                        // doc.data() will be undefined in this case
                        console.log('No such document!')
                      }
                     
                    })
                    .catch((error) => {
                      console.log(error)
                      
                    })
                })
              })
              .catch(function(error) {
                console.log('Error getting documents: ', error)
              })
          })


          .then(() => {
            firebase.firestore().collection('users').doc(payload.uid).collection('notifications').where('new', '==', true).orderBy('requestTime', 'desc').get()
              .then((notificationsList) => {

                notificationsList.forEach((notificationDoc) => {
                  const notification = notificationDoc.data()
                  // console.log('notification', notification)
                  firebase.firestore().collection('users').doc(notification.friendId).get()
                  
                    .then((notificationSnapshot) => {
                      if (notificationSnapshot.exists) {
                        const notificationData = {
                          subject: notification.subject,
                          friendId: notificationSnapshot.data().id,
                          uniqueId: notificationSnapshot.data().uniqueId,
                          friendName: notificationSnapshot.data().name,
                          friendStatus: notificationSnapshot.data().status,
                          friendProfileImg: notificationSnapshot.data().profileImg,
                          icon: notification.icon,
                          title: notification.title,
                          new: notification.new,
                          notificationId: notificationDoc.id,
                          requestTime: notification.requestTime
                        }
                        commit('setNotifications', notificationData)
                        // console.log('notificationData', notificationData)
                        // console.log('notificationDoc', notificationDoc)
                      } else {
                        // doc.data() will be undefined in this case
                        console.log('No such document!')

                        // Delete Notification (because User was deleted)
                        firebase.firestore().collection('users').doc(payload.uid).collection('notifications').doc(notificationDoc.id).delete().then(function() {
                          console.log('Document successfully deleted!')
                        }).catch(function(error) {
                          console.error('Error removing document: ', error)
                        })
                      }
                     
                    })
                    .catch((error) => {
                      console.log(error)
                      
                    })
                })
              })
              .catch(function(error) {
                console.log('Error getting documents: ', error)
              })
          })
          .then(() => {
            firebase.firestore().collection('users').doc(payload.uid).collection('notifications').where('new', '==', false).orderBy('requestTime', 'desc').limit(12).get()
              .then((notificationsList) => {
                console.log('notiExist', notificationsList)
                notificationsList.forEach((notificationDoc) => {
                  const notification = notificationDoc.data()
                  console.log('notification', notification)
                  firebase.firestore().collection('users').doc(notification.friendId).get()
                    .then((notificationSnapshot) => {
                      if (notificationSnapshot.exists) {
                        const notificationData = {
                          subject: notification.subject,
                          friendId: notificationSnapshot.data().id,
                          uniqueId: notificationSnapshot.data().uniqueId,
                          friendName: notificationSnapshot.data().name,
                          friendStatus: notificationSnapshot.data().status,
                          friendProfileImg: notificationSnapshot.data().profileImg,
                          icon: notification.icon,
                          title: notification.title,
                          new: notification.new,
                          notificationId: notificationDoc.id,
                          requestTime: notification.requestTime
                        }
                        
                        commit('setNotifications', notificationData)
                        console.log('notificationData', notificationData)
                      } else {
                        // doc.data() will be undefined in this case
                        console.log('No such document!')

                        // Delete Notification (because User was deleted)
                        firebase.firestore().collection('users').doc(payload.uid).collection('notifications').doc(notificationDoc.id).delete()
                          .then(function() {
                            console.log('Document successfully deleted!')
                          }).catch(function(error) {
                            console.error('Error removing document: ', error)
                          })
                      }
                      

                    })
                    .catch((error) => {
                      console.log(error)
                      
                    })
                })
              })
              .catch(function(error) {
                console.log('Error getting documents: ', error)
              })
          })
          .then(() => {

            firebase.firestore().collection('users').doc(payload.uid).collection('favMoments').where('date', '>=', dateminus1day).orderBy('date', 'desc').get()
              .then((favMomentsList) => {

                favMomentsList.forEach((favMomentsDoc) => {
                  const favMoment = favMomentsDoc.data()
                  console.log(payload.uid, favMoment)
                  console.log('friends', rootState.user.myFriends)
                  // check if user is still a 'Friend'
                  if (favMoment.creatorId === payload.uid) {
                    commit('setFavMoments', favMoment)
                  } else {
                    if (rootState.user.myFriends.some(friend => friend.friendId === favMoment.creatorId && friend.acceptedByFriend === true && friend.acceptedByUser === true)) {
                      commit('setFavMoments', favMoment)
                    } else {
                      // delete FavMoment if User is no Friend anymore
                      firebase.firestore().collection('users').doc(payload.uid).collection('favMoments').doc(favMomentsDoc.id).delete()
                        .then(()=> {
                          commit('delFavMoments', favMoment)

                        })
                        .catch((error) => {
                          console.log(error)
                        })
                      
                    }
                  }
                 
                })
              })
              .catch(function(error) {
                console.log('Error getting documents: ', error)
              })
          })

          .then(() => {
            firebase.firestore().collection('users').doc(payload.uid).collection('favEvents').where('date', '>', dateminus1day).orderBy('date', 'desc').get()
              .then((favEventsList) => {

                favEventsList.forEach((favEventsDoc) => {
                  const favEvent = favEventsDoc.data()
                  commit('setFavEvents', favEvent)
                })
              })
              .catch(function(error) {
                console.log('Error getting documents: ', error)
              })
          })
        
          .then(() => {
            return dispatch('loadEvents')
          })
          .then(() => {
            return dispatch('loadMoments')
          })
         

          .then(() => {
            // set StandardFilter
            setTimeout(function() {
              dispatch('filterPosts', ({isFilterSet: true}))

            }, 1000)

          })
          .then(() => {
            // commit('setUser', user)
            
            commit('setLoading', false)
            commit('setRefreshLoading', false)
            
          })
         
        

          .catch((error) => {
            console.log('AutoSignInError', error)
            dispatch('logout')
            commit('setLoading', false)
            commit('setRefreshLoading', false)

            commit('setError', error)
          })
      } else {
        console.log('emailIstNichtVerifiziert')
        commit('setIsNotVerified', payload.email)
        commit('setPleaseVerifyMail', true)
        
        commit('setRefreshLoading', false)
        
        commit('setLoading', false)

      }
      
    },

    deleteAccount ({commit, dispatch}, payload) {
      commit('setLoading', true)
  
      commit('clearError')
      let user = firebase.auth().currentUser
      const credential = firebase.auth.EmailAuthProvider.credential(
        user.email,
        payload
      )
      let createdEvents = {}
      if (user) {
  
        user.reauthenticateAndRetrieveDataWithCredential(credential)
        // User re-authenticated.
          .then(() => {
            

            return firebase.firestore().collection('users').doc(user.uid).collection('createdEvents').get()
              .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                  
                  createdEvents[doc.id] = doc.data()

                })
              })
              .catch(function(error) {
                console.log('Error getting documents: ', error)
              })
          })
          .then(() => {
            

            // CloudFunction auslösen um rekursiv die Events zu löschen
            function deleteEvents(createdEvents, userId) {
              var deleteFn = firebase.functions().httpsCallable('deleteEventsUser')
              deleteFn({ createdEvents, userId })
                .then(function(result) {
                  console.log('Delete success: ' + JSON.stringify(result))
                })
                .catch(function(err) {
                  console.log('Delete failed, see console,')
                  console.warn(err)
                })
            }

            function deleteEventsImages(createdEvents, userId) {
              var deleteFn = firebase.functions().httpsCallable('deleteEventsImages')
              deleteFn({ createdEvents, userId })
                .then(function(result) {
                  console.log('Delete success: ' + JSON.stringify(result))
                })
                .catch(function(err) {
                  console.log('Delete failed, see console,')
                  console.warn(err)
                })
            }
            console.log('createdEvents', createdEvents)

            deleteEvents(createdEvents, user.uid)
            deleteEventsImages(createdEvents, user.uid)

          })
          .then(() => {

            // CloudFunction auslösen um rekursiv auch die Subcollctions Notifications zu löschen
            function deleteNotifications(path) {
              var deleteFn = firebase.functions().httpsCallable('deleteProfileSubColNotifications')
              deleteFn({ path: path })
                .then(function(result) {
                  console.log('Delete success: ' + JSON.stringify(result))
                })
                .catch(function(err) {
                  console.log('Delete failed, see console,')
                  console.warn(err)
                })
            }

            // CloudFunction auslösen um rekursiv auch die Subcollctions Friends zu löschen
            function deleteFriends(path) {
              var deleteFn = firebase.functions().httpsCallable('deleteProfileSubColFriends')
              deleteFn({ path: path })
                .then(function(result) {
                  console.log('Delete success: ' + JSON.stringify(result))
                })
                .catch(function(err) {
                  console.log('Delete failed, see console,')
                  console.warn(err)
                })
            }

            // CloudFunction auslösen um rekursiv auch die Subcollctions createdMoments zu löschen
            function deleteCreatedMoments(path) {
              var deleteFn = firebase.functions().httpsCallable('deleteProfileSubColCreatedMoments')
              deleteFn({ path: path })
                .then(function(result) {
                  console.log('Delete success: ' + JSON.stringify(result))
                })
                .catch(function(err) {
                  console.log('Delete failed, see console,')
                  console.warn(err)
                })
            }

            // CloudFunction auslösen um rekursiv auch die Subcollctions createdEvents zu löschen
            function deleteCreatedEvents(path) {
              var deleteFn = firebase.functions().httpsCallable('deleteProfileSubColCreatedEvents')
              deleteFn({ path: path })
                .then(function(result) {
                  console.log('Delete success: ' + JSON.stringify(result))
                })
                .catch(function(err) {
                  console.log('Delete failed, see console,')
                  console.warn(err)
                })
            }

            // CloudFunction auslösen um rekursiv auch die Subcollctions favMoments zu löschen
            function deleteFavMoments(path) {
              var deleteFn = firebase.functions().httpsCallable('deleteProfileSubColFavMoments')
              deleteFn({ path: path })
                .then(function(result) {
                  console.log('Delete success: ' + JSON.stringify(result))
                })
                .catch(function(err) {
                  console.log('Delete failed, see console,')
                  console.warn(err)
                })
            }

            // CloudFunction auslösen um rekursiv auch die Subcollctions favMoments zu löschen
            function deleteFavEvents(path) {
              var deleteFn = firebase.functions().httpsCallable('deleteProfileSubColFavEvents')
              deleteFn({ path: path })
                .then(function(result) {
                  console.log('Delete success: ' + JSON.stringify(result))
                })
                .catch(function(err) {
                  console.log('Delete failed, see console,')
                  console.warn(err)
                })
            }


            deleteNotifications(user.uid)
            deleteFriends(user.uid)
            deleteCreatedMoments(user.uid)
            deleteCreatedEvents(user.uid)
            deleteFavMoments(user.uid)
            deleteFavEvents(user.uid)

          })
          .then(() => {
            // Userprofil löschen
            firebase.firestore().collection('users').doc(user.uid).delete()
              .then(function() {
                console.log('Document successfully deleted!')

  
              }).catch(function(error) {
                console.error('Error removing document: ', error)
              })
          })
          .then(() => {
            // Alle Moments des Users löschen
            // CloudFunction auslösen um rekursiv die Moments zu löschen
            function deleteMoments(path) {
              var deleteFn = firebase.functions().httpsCallable('deleteMomentsUser')
              deleteFn({ path: path })
                .then(function(result) {
                  console.log('Delete success: ' + JSON.stringify(result))
                })
                .catch(function(err) {
                  console.log('Delete failed, see console,')
                  console.warn(err)
                })
            }

            deleteMoments(user.uid)


          })
          
          .then(() => {
          
            // Storage - Profilbild löschen
            var profileImgRef = firebase.storage().ref()
            profileImgRef.child('users/' + user.uid + '/' + user.uid).delete()
              .then(function() {
              // File deleted successfully
                console.log('ProfileImg deleted')
              })
              .catch(function(error) {
              // Uh-oh, an error occurred!
                console.log(error)
              })


          })
          .then(() => {
          // Delete UserAccount (Authentication)
            user.delete()
              .then(function() {
              
                commit('setLoading', false)
                dispatch('logout')

              })
              .catch(function(error) {
                // An error happened.
                console.log('error', error)
                commit('setError', error)
                commit('setLoading', false)

              })
          })
          .catch(function(error) {
          // An error happened.
            console.log('errorReAuth', error)
            commit('setError', error)
            commit('setLoading', false)

          })
  
      }      
    },
    
  }
}